import { z } from "zod";
import { platformRoleSchema, roleSchema } from "../enums.js";

export const sessionUserSchema = z.object({
  userId: z.string(),
  email: z.string().email(),
  fullName: z.string().nullable(),
  organizationId: z.string().nullable(),
  organizationName: z.string().nullable(),
  role: roleSchema.nullable(),
  platformRole: platformRoleSchema,
});
export type SessionUser = z.infer<typeof sessionUserSchema>;

export const startLoginResponseSchema = z.object({ authorizeUrl: z.string().url() });
export type StartLoginResponse = z.infer<typeof startLoginResponseSchema>;

export const updateProfileSchema = z.object({
  fullName: z.string().trim().max(200).nullable(),
});
export type UpdateProfileInput = z.infer<typeof updateProfileSchema>;
